import React from 'react';

import mapModifiers from 'utils/functions';

export const iconList = {
  arrowLeft: 'arrowLeft',
  arrowRight: 'arrowRight',
  chervonRight: 'chervonRight',
  keyboardArrowRight: 'keyboardArrowRight',
  keyboardArrowRightLinear: 'keyboardArrowRightLinear',
  notiActive: 'notiActive',
  time: 'time',
  triagleDownBlack: 'triagleDownBlack',
  triagleDownRed: 'triagleDownRed',
  triangleDownLinear: 'triangleDownLinear',
  triagleRight: 'triagleRight',
  triagleUp: 'triagleUp',
  phone: 'phone',
  phoneGreen: 'phoneGreen',
  phoneBlack: 'phoneBlack',
  phoneGray: 'phoneGray',
  search: 'search',
  login: 'login',
  poll: 'poll',
  headset: 'headset',
  monetization: 'monetization',
  personAdd: 'personAdd',
  support: 'support',
  close: 'close',
  closeGreen: 'closeGreen',
  downLoad: 'downLoad',
  logout: 'logout',
  hamburger: 'hamburger',
  facebook: 'facebook',
  linkedin: 'linkedin',
  twitter: 'twitter',
  youtube: 'youtube',
  notiValid: 'notiValid',
  notiError: 'notiError',
  feather: 'feather',
  building: 'building',
  live: 'live',
  calendar: 'calendar',
  chervonRightWhite: 'chervonRightWhite',
  arrowDropUp: 'arrowdropup',
  arrowDropUpWhite: 'arrowDropUpWhite',
  chervonNextLight: 'chervonNextLight',
  chervonNextDeepDark: 'chervonNextDeepDark',
  chervonPrevLight: 'chervonPrevLight',
  chervonPrevDeepDark: 'chervonPrevDeepDark',
  skipNextLight: 'skipNextLight',
  skipNextDeepDark: 'skipNextDeepDark',
  skipPrevLight: 'skipPrevLight',
  skipPrevDeepDark: 'skipPrevDeepDark',
  marker: 'marker',
  arrowForwardBlack: 'arrowForwardBlack',
  star: 'star',
  starRadius: 'starRadius',
  arrowForwardGreen: 'arrowForwardGreen',
  rate: 'rate',
  rateFull: 'rateFull',
  zoomOutLight: 'zoomOutLight',
  zoomOutDark: 'zoomOutDark',
  arrowUpGreen: 'arrowUpGreen',
  arrowUpGreenDark: 'arrowUpGreenDark',
  arrowUpPurple: 'arrowUpPurple',
  arrowShortRight: 'arrowShortRight',
  arrowDownBlue: 'arrowDownBlue',
  arrowDownRed: 'arrowDownRed',
  searchBlack: 'searchBlack',
  searchWhite: 'searchWhite',
  searchGray: 'searchGray',
  searchEerieBlack: 'searchEerieBlack',
  cancelGray: 'cancelGray',
  cancelWhite: 'cancelWhite',
  visibility: 'visibility',
  visibilityOff: 'visibilityOff',
  downloadYellow: 'downloadYellow',
  expandYellow: 'expandYellow',
  expandLinear: 'expandLinear',
  downloadLinear: 'downloadLinear',
  filter: 'filter',
  keyGreen: 'keyGreen',
  keyDeepGreen: 'keyDeepGreen',
  email: 'email',
  locationOn: 'locationOn',
  playArrow: 'playArrow',
  cameraBlue: 'cameraBlue',
  assignDark: 'assignDark',
  assignLight: 'assignLight',
  businessDark: 'businessDark',
  businessLight: 'businessLight',
  chartDark: 'chartDark',
  chartLight: 'chartLight',
  clockDark: 'clockDark',
  clockLight: 'clockLight',
  clock: 'clock',
  copyDark: 'copyDark',
  copyLight: 'copyLight',
  forwardDark: 'forwardDark',
  forwardLight: 'forwardLight',
  moneyDark: 'moneyDark',
  moneyLight: 'moneyLight',
  noticeDark: 'noticeDark',
  noticeLight: 'noticeLight',
  starDark: 'starDark',
  starLight: 'starLight',
  starBorder: 'starBorder',
  starFull: 'starFull',
  trendupDark: 'trendupDark',
  trendupLight: 'trendupLight',
  arrowDownRedDark: 'arrowDownRedDark',
  horizontalThreeDots: 'horizontalThreeDots',
  keyboardArrowLeft: 'keyboardArrowLeft',
  timeWhite: 'timeWhite',
  attachMoney: 'attachMoney',
  attachMoneyGradient: 'attachMoneyGradient',
  logoutWhite: 'logoutWhite',
  triagleDownWhite: 'triagleDownWhite',
  closeWhite: 'closeWhite',
  warningRed: 'warningRed',
  notifySuccess: 'notifySuccess',
  notifyError: 'notifyError',
  delete: 'delete',
  errorOutline: 'errorOutline',
  chatWhite: 'chatWhite',
  cloudUpload: 'cloudUpload',
  photoCamera: 'photoCamera',
  circleCheck: 'circleCheck',
  person: 'person',
  lock: 'lock',
  userBlack: 'userBlack',
  closeDavysGrey: 'closeDavysGrey',
  noDataLight: 'noDataLight',
  noDataDark: 'noDataDark',
  libraryAdd: 'libraryAdd',
  userProfile: 'userProfile',
  upload: 'upload',
  createNew: 'createNew',
  personSolid: 'personSolid',
  cameraGreen: 'cameraGreen',
  cameraWhite: 'cameraWhite',
  edit: 'edit',
  arrowUpward: 'arrowUpward',
  createNewGray: 'createNewGray',
  emailGray: 'emailGray',
  lockGray: 'lockGray',
  education: 'education',
  graduationGrade: 'graduationGrade',
  academicLevel: 'academicLevel',
  trainingSchool: 'trainingSchool',
  personSearch: 'personSearch',
  personSearchGrey: 'personSearchGrey',
  calendarBlack: 'calendarBlack',
  calendarGray: 'calendarGray',
  heartOutlined: 'heartOutlined',
  heartFill: 'heartFill',
  share: 'share',
  location: 'location',
  union: 'union',
  trash: 'trash',
  folderGray: 'folderGray',
  folderGradient: 'folderGradient',
  downloadWhite: 'downloadWhite',
  searchJob: 'searchJob',
  arrowDownLinear: 'arrowDownLinear',
  job: 'job',
  locationJob: 'locationJob',
  recruitType: 'recruitType',
  sort: 'sort',
  volume: 'volume',
  unmute: 'unmute',
  pause: 'pause',
  play: 'play',
  grid: 'grid',
  gridActive: 'gridActive',
  list: 'list',
  listActive: 'listActive',
  cvProcess: 'cvProcess',
  locationGray: 'locationGray',
  workGray: 'workGray',
  trendingDownGray: 'trendingDownGray',
  moneyGray: 'moneyGray',
  headSideCough: 'headSideCough',
  hearing: 'hearing',
  reading: 'reading',
  speaker: 'speaker',
  writing: 'writing',
  editWhite: 'editWhite',
  notebook: 'notebook',
  puzzle: 'puzzle',
  heartOutlinedLinear: 'heartOutlinedLinear',
  shareLinear: 'shareLinear',
  file: 'file',
  bookReader: 'bookReader',
  educationType: 'educationType',
  level: 'level',
  height: 'height',
  creditCard: 'creditCard',
  marrageStatus: 'marrageStatus',
  money: 'money',
  relationship: 'relationship',
  flag: 'flag',
  attachMoneyRm: 'attachMoneyRm',
  saveWhite: 'saveWhite',
  dollarDark: 'dollarDark',
  insuranceDark: 'insuranceDark',
  educateDark: 'educateDark',
  planeDark: 'planeDark',
  medicalDark: 'medicalDark',
  titlesDark: 'titlesDark',
  folderGreen: 'folderGreen',
  playListAddCheck: 'playListAddCheck',
  copyLinear: 'copyLinear',
  heartRed: 'heartRed',
};

export type IconName = keyof typeof iconList;

export type IconSize = '12'| '13' | '14' | '16' | '18' | '20' | '22' | '24' | '28' | '30' | '32' | '40' | '48' | '60' | '100' | '120' | '80';

type Props = {
  iconName: IconName;
  size?: IconSize;
};

const Icon: React.FC<Props> = ({ iconName, size }) => (
  <i className={mapModifiers('a-icon', iconName, size)} />
);

Icon.defaultProps = {
  size: '24',
};

export default Icon;
